import React from 'react';

interface PillButtonProps {
  label: string;
  onClick: () => void;
  selected?: boolean;
}

export const PillButton: React.FC<PillButtonProps> = ({ label, onClick, selected = false }) => (
  <button
    onClick={onClick}
    className={`rounded-pill border px-4 py-1.5 text-sm font-medium transition-colors ${
      selected
        ? 'bg-coral border-coral text-white'
        : 'border-coral text-coral bg-white hover:bg-coral/5'
    }`}
  >
    {label}
  </button>
);
